import React from 'react';

import Button from 'components/form/Button.component';
import CurrencySign from 'components/price/CurrencySign.component';
import DELAY from 'constants/delay.const';
import { withTranslation } from 'providers/GILT.provider';
import delayed from 'utils/functions/delayed.util';

import DropdownMenuFooter from 'clientCommunications/components/Clients/common/DropdownMenuFooter.component';

class LoyaltyDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 'any-amount',
      value2: 'any-number',
      inputVal: '',
      count: 0,
      edited: false,
    };
  }

  onChangeRadio = (event) => {
    const inputMoreThan = document.getElementById('spent-more-than');
    this.setState({
      value: event.currentTarget.value,
      edited: true,
    });
    if (event.currentTarget.value === 'any-amount') {
      this.setState({
        inputVal: '',
      });
    }
    if (event.currentTarget.value === 'more-than') {
      this.setState({
        inputVal: '',
      });
      if (inputMoreThan) {
        inputMoreThan.focus();
      }
    }
  };
  onChangeInput = (event) => {
    let editAmount = event.target.value;
    if (editAmount === '') {
      editAmount = 0;
    } else if (this.isNaN(editAmount)) {
      return;
    }
    this.setState({
      value: 'more-than',
      inputVal: event.target.value,
    });
  };
  onChangeRadioVisited = (event) => {
    this.setState({
      value2: event.currentTarget.value,
      edited: true,
    });
    if (event.currentTarget.value === 'any-number') {
      this.setState({ count: 0 });
    }
    if (event.currentTarget.value === 'counter-number') {
      this.setState({ count: 1 });
    }
  };
  onDecrement = () => {
    if (this.state.count > 0) {
      this.setState({ count: this.state.count - 1 });
    }
  };
  onIncrement = () => {
    this.setState({ count: this.state.count + 1 });
  };
  onDone = () => {
    this.props.onDoneLoyalty(this.state.value === 'more-than', this.state.inputVal, this.state.value2 === 'counter-number', this.state.count);
    this.setState({ edited: false });
  };
  isNaN = (value) => {
    const n = Number(value);
    // eslint-disable-next-line no-self-compare
    return n !== n;
  };

  render() {
    if (this.props.selectedLoyalty && this.props.selectedLoyalty.isAnyAmount === undefined && !this.state.edited) {
      delayed(DELAY.workaround, () => {
        this.setState({
          value: 'any-amount',
          inputVal: '',
          value2: 'any-number',
          count: 0,
          edited: true,
        });
      });
    }

    const { t } = this.props;

    return (
      <div className={`drop-down dd-loyalty ${this.props.isLoyalty ? '' : 'hidden'} `}>
        <div className="main">
          <span className="span-header">{t('allClients.loyaltyDropdown.title')}</span>
          <div id="loyalty-filter">
            <div className="row radio-group">
              <label className="radio-btn" htmlFor="r1">
                <input id="r1" value="any-amount" name="r1" type="radio" checked={this.state.value === 'any-amount'} onChange={this.onChangeRadio} />
                <span className="checkmark" />
                <div className="radio-text">
                  <span className="text-before">{t('allClients.loyaltyDropdown.anyAmount')}</span>
                </div>
              </label>
              <label className="radio-btn" htmlFor="r2">
                <input id="r2" value="more-than" name="r2" type="radio" checked={this.state.value === 'more-than'} onChange={this.onChangeRadio} />
                <span className="checkmark for-spent-more" />
                <div className="radio-text for-spent-more">
                  <span className="text-before">{t('allClients.loyaltyDropdown.moreThan')}</span>

                  <span className="text-after">
                    <CurrencySign />
                  </span>
                  <div className="input-val-container">
                    <input value={this.state.inputVal} name="inputMoreThan" type="text" className="input-default" id="spent-more-than" onChange={this.onChangeInput} onBlur={this.onChangeInput} />
                  </div>
                </div>
              </label>
            </div>
            <span className="divider">{t('common.and')}</span>
            <div className="row radio-group">
              <label className="radio-btn" htmlFor="r3">
                <input id="r3" value="any-number" name="r3" type="radio" checked={this.state.value2 === 'any-number'} onChange={this.onChangeRadioVisited} />
                <span className="checkmark" />
                <div className="radio-text">
                  <span className="text-before">{t('allClients.loyaltyDropdown.anyVisits')}</span>
                </div>
              </label>
              <label className="radio-btn" htmlFor="r4">
                <input id="r4" value="counter-number" name="r4" type="radio" checked={this.state.value2 === 'counter-number'} onChange={this.onChangeRadioVisited} />
                <span className="checkmark" />
                <div className="radio-text for-visited-times">
                  <span className="text-before">{t('allClients.loyaltyDropdown.counterNumber')}</span>
                  <div className="counter-container">
                    <div className="incr" onClick={this.onIncrement} role="button" tabIndex={0} />
                    <span className="visited-times">{this.state.count}</span>
                    <div className="decr" onClick={this.onDecrement} role="button" tabIndex={0} />
                  </div>
                  <span className="text-after">{t('allClients.loyaltyDropdown.timesOrMore')}</span>
                </div>
              </label>
            </div>
          </div>

          <DropdownMenuFooter>
            <Button variant="slim" onClick={this.onDone}>
              {t('common.buttons.doneUpp')}
            </Button>
          </DropdownMenuFooter>
        </div>
      </div>
    );
  }
}

export default withTranslation()(LoyaltyDropDown);
